<template>
  <main-layout>
    <iframe
      sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
      allowfullscreen="true"
      :src="src"
      :style="{
        display: 'block',
        border: 'none',
        position: 'absolute',
        width: '100%',
        height: 'calc(100dvh - var(--nav-height))'
      }"
    />
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['currentLang']),
    src() {
      if (!this.currentLang) return ''
      return `https://cms.enterprise.zwiz.app/${this.currentLang}/axa/cars`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/axa/CarManagementIframe.vue